// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-locations-access-form h4{margin-bottom:1rem}.user-locations-access-form .sub-title{color:#666;font-weight:600}.user-locations-access-form .search-field{padding:10px}.user-locations-access-form .search-field div{padding:0}.user-locations-access-form .search-field button.btn-icon{border:none!important;box-shadow:none!important;width:10px}.user-locations-access-form .search-field button.btn-outline-secondary{width:48px!important}", ""]);
// Exports
module.exports = exports;
